import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Dark full-width page section with a centered title and projected content.
 * Shared by the home and tool pages for the FAQ, features and more-tools blocks.
 */
@Component({
  selector: 'lib-dark-section',
  imports: [TranslateModule],
  templateUrl: './dark-section.component.html',
  styleUrl: './dark-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DarkSectionComponent {
  readonly titleKey = input.required<string>();
  /** Id of the heading, referenced by the section's aria-labelledby. */
  readonly headingId = input.required<string>();
  /** Narrow container variant used for reading-oriented content like FAQs. */
  readonly narrow = input(false);
}
